import { createStore } from 'vuex'; // Use createStore for Vue 3
// You don't need Vue.use(Vuex) anymore

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
